import {AbstractAccessGrant} from './AbstractAccessGrant';

export class UserDynamicFeature extends AbstractAccessGrant {
chronoCode: string;
kind: string;
login: string;
pageIndex: number | null;
pageSize: number | null;
scenario: string;
}

